import api, { withBusiness } from "./api";

export async function listTimeOff(params = {}) {
  const url = withBusiness("/b/time-off");
  const { data } = await api.get(url, { params });
  return Array.isArray(data) ? data : [];
}

export async function createTimeOff(payload) {
  const url = withBusiness("/b/time-off");
  const { data } = await api.post(url, payload);
  return data;
}

export async function patchTimeOff(id, payload) {
  const url = withBusiness(`/b/time-off/${id}`);
  const { data } = await api.patch(url, payload);
  return data;
}

export async function deleteTimeOff(id) {
  const url = withBusiness(`/b/time-off/${id}`);
  await api.delete(url);
  return true;
}
